var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-drawer',{attrs:{"visible":_vm.visible,"maskClosable":false,"width":800,"body-style":{ paddingBottom: '80px' },"title":_vm.title},on:{"update:visible":function($event){_vm.visible=$event},"close":_vm.onClose}},[_c('a-table',{attrs:{"columns":_vm.columns,"data-source":_vm.data,"scroll":{ x: true },"pagination":false},scopedSlots:_vm._u([{key:"shop_name",fn:function(text, record){return [_c('a',{on:{"click":function($event){return _vm.goToShopDetail(record.shop_id)}}},[_vm._v(_vm._s(record.shop_name))])]}}])}),_c('div',{style:({
    position: 'absolute',
    right: 0,
    bottom: 0,
    width: '100%',
    borderTop: '1px solid #e9e9e9',
    padding: '10px 16px',
    background: '#fff',
    textAlign: 'right',
    zIndex: 1,
  })},[_c('a-button',{style:({ marginRight: '8px' }),on:{"click":_vm.onClose}},[_vm._v(" 关闭 ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }